// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
import { Controller } from "@hotwired/stimulus"


require('summernote/dist/summernote-bs4.js');
require('summernote/dist/summernote-bs4.css');
require('summernote/dist/lang/summernote-ru-RU.min.js');

export default class extends Controller {

  static targets = [ "textarea" ]

  initialize() {
    // $.ajax({
    //   url: 'https://api.github.com/emojis'
    // }).then(function(data) {
    //   window.emojis = Object.keys(data);
    //   window.emojiUrls = data;
    // })
  }

  connect() {
    if (this.textareaTargets.length > 0) {
      this.textareaTargets.forEach((el) => {
        // debugger
        this.summernotemount($(el))
        // debugger
        document.addEventListener('turbolinks:before-cache', () => {
          this.summernoteunmount($(el))
        }, {once: true})
      })
    }

    const el = $( this.element )


  }''

  summernotemount(theArea) {
    let config = {
      height: theArea.data('height') ?? 100,
      focus: true,
      lang: 'ru-RU',
      prettifyHtml: true,
      callbacks: {
        onPaste: function (e) {
          console.log('paste it')
          const bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text')
          e.preventDefault()
          setTimeout(function () {
            document.execCommand('insertText', false, bufferText)
          }, 10)
        }
      }
      // placeholder: 'Text here',
    }

    config['toolbar'] = [
      // [groupName, [list of button]]
      ['style', ['style']],
      ['style', ['bold', 'italic', 'underline', 'clear']],
      ['font', ['strikethrough', 'superscript', 'subscript']],
      ['fontsize', ['fontsize']],
      ['color', ['color']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['table', ['table']],
      // ['insert', ['link', 'picture', 'video']],
      // ['height', ['height']],
      ['view', ['fullscreen', 'codeview', 'help']]
    ]

    // config['hint'] = {
    //   match: /:([\-+\w]+)$/,
    //   search: (keyword, callback) => {
    //     callback($.grep(emojis, function (item) {
    //       return item.indexOf(keyword)  === 0
    //     }));
    //   },
    //   template: (item) => {
    //     const content = emojiUrls[item]
    //     return '<img src="' + content + '" width="20" /> :' + item + ':'
    //   },
    //   content: (item) => {
    //     const url = emojiUrls[item]
    //     if (url) {
    //       return $('<img />').attr('src', url).css('width', 20)[0]
    //     }
    //     return '';
    //   }
    // }

    theArea.summernote(config)
  }

  summernoteunmount(theArea) {
    theArea.summernote('destroy')
  }

}
